import Typography from "@mui/material/Typography";

const CompanyHistory = () => {
  return (
    <>
      <Typography sx={{ textAlign: "justify" }}>
        شرکت صنایع نگین آلومینیوم گلپایگان با تجربه بیش از یک دهه مدیران خود در
        زمینه ریخته گری آلومینیوم،فعالیت خود را در زمینه تولید شمش های آلیاژی
        آلومینیوم از سال 1392 با ظرفیت تولید سالانه 15000 تن در شهرک صنعتی
        شهرستان گلپایگان آغاز نمود. این شرکت هم اکنون توانایی تولید خود را تا
        30000 تن شمش آلیاژی ارتقا داده و افزایش تا مرز 50000تن در سال را در
        برنامه توسعه خود قرار داده است. این شرکت با تکیه بر تجربه هیئت موسس خود
        توانست در مدت زمان کم از تاسیس شرکت با اکثر صنایع کشتی سازی،
        هواپیماسازی، شرکت های خودرو سازی همچون مگاموتور و ساپکو و انواع شرکت های
        لوازم خانگی،صنایع برق و گاز و سیستم های گرمایشی و ... همکاری نزدیکی
        داشته باشد. نگرش مشتری مداری حاکم بر فعالیت های گروه از همان ابتدای راه
        موجب شده است تا رضایت مشتریان،بهبود کیفیت محصولات،نوآوری مستمر و خدمات
        پس از فروش جزو مهم ترین اصول و ارزش های فعالیت های این شرکت باشد.
        استاندارد های تولید و کنترل کیفیت در بالاترین حد ممکن تعیین شده است و
        کلیه محصولات قبل از خروج از خط تولید ،تحت دقیق ترین آزمایش های کنترل
        کیفیت قرار می گیرند. اخذ گواهینامه ایزو 9001 و حضور قدرتمند در بازارهای
        داخلی و خارجی شاهدی بر این مدعی است. ضمناٌ این شرکت رضایت و خشنودی مشتری
        خود را از اولویت های برنامه ریزی شرکت خود می داند و برای رسیدن به آن از
        هیچ کوششی دریغ نمی نماید و با اتکا به مزیت های رقابتی نظیر کیفیت
        ممتاز،قیمت به مراتب کمتر از قیمت بازار و شرایط پرداخت بسیار مناسب
        توانسته است به راحتی با تمام رقبای داخلی و خارجی به رقابت بپردازد.
      </Typography>
    </>
  );
};

export default CompanyHistory;
